export var ArcPageEnum;
(function (ArcPageEnum) {
    /** ARC v1 */
    ArcPageEnum["HOME"] = "Home";
    ArcPageEnum["ABOUT"] = "About";
    ArcPageEnum["CONTACT"] = "Contact";
    ArcPageEnum["POSTS"] = "Posts";
    ArcPageEnum["POST"] = "Post";
    ArcPageEnum["CIPHERS"] = "Ciphers";
    ArcPageEnum["CIPHER"] = "Cipher";
    /** ARC v2 */
    ArcPageEnum["v2_HOME"] = "v2_Home";
    ArcPageEnum["v2_POSTS"] = "v2_Posts";
    ArcPageEnum["v2_POST_DETAIL"] = "v2_Post_Detail";
    ArcPageEnum["v2_RFCS"] = "v2_Rfcs";
    ArcPageEnum["v2_RFC_DETAIL"] = "v2_Rfc_Detail";
    ArcPageEnum["v2_ABOUT"] = "v2_About";
    ArcPageEnum["v2_CONTACT"] = "v2_Contact";
})(ArcPageEnum || (ArcPageEnum = {}));
export const ArcBrowserRuntimeRoutesEnum = {
    [ArcPageEnum.HOME]: "/archives/v1",
    [ArcPageEnum.ABOUT]: "/archives/v1/about",
    [ArcPageEnum.CONTACT]: "/archives/v1/contact",
    [ArcPageEnum.POSTS]: "/archives/v1/posts",
    [ArcPageEnum.POST]: "/archives/v1/post/:id",
    [ArcPageEnum.CIPHERS]: "/ee/ciphers",
    [ArcPageEnum.CIPHER]: "/ee/cipher/:id",
    [ArcPageEnum.v2_HOME]: "/",
    [ArcPageEnum.v2_POSTS]: "/posts",
    [ArcPageEnum.v2_POST_DETAIL]: "/post/:postId",
    [ArcPageEnum.v2_RFCS]: "/rfcs",
    [ArcPageEnum.v2_RFC_DETAIL]: "/rfc/:rfcId",
    [ArcPageEnum.v2_ABOUT]: "/about",
    [ArcPageEnum.v2_CONTACT]: "/contact"
};
export var ArcPrerenderStaticRouteEnum;
(function (ArcPrerenderStaticRouteEnum) {
    ArcPrerenderStaticRouteEnum["HOME"] = "https://nickgalante.tech/archives/v1";
    ArcPrerenderStaticRouteEnum["CIPHERS"] = "https://nickgalante.tech/ee/ciphers";
    ArcPrerenderStaticRouteEnum["POSTS"] = "https://nickgalante.tech/archives/v1/posts";
    ArcPrerenderStaticRouteEnum["ABOUT"] = "https://nickgalante.tech/archives/v1/about";
    ArcPrerenderStaticRouteEnum["CONTACT"] = "https://nickgalante.tech/archives/v1/contact";
    ArcPrerenderStaticRouteEnum["v2_HOME"] = "https://nickgalante.tech/";
    ArcPrerenderStaticRouteEnum["v2_POSTS"] = "https://nickgalante.tech/posts";
    ArcPrerenderStaticRouteEnum["v2_RFCS"] = "https://nickgalante.tech/rfcs";
    ArcPrerenderStaticRouteEnum["v2_ABOUT"] = "https://nickgalante.tech/about";
    ArcPrerenderStaticRouteEnum["v2_CONTACT"] = "https://nickgalante.tech/contact";
})(ArcPrerenderStaticRouteEnum || (ArcPrerenderStaticRouteEnum = {}));
export var ArcPrerenderDynamicRouteEnum;
(function (ArcPrerenderDynamicRouteEnum) {
    ArcPrerenderDynamicRouteEnum["CIPHER"] = "https://nickgalante.tech/ee/cipher/:id";
    ArcPrerenderDynamicRouteEnum["POST"] = "https://nickgalante.tech/archives/v1/post/:id";
    ArcPrerenderDynamicRouteEnum["v2_POST_DETAIL"] = "https://nickgalante.tech/post/:postId";
    ArcPrerenderDynamicRouteEnum["v2_RFC_DETAIL"] = "https://nickgalante.tech/rfc/:rfcId";
})(ArcPrerenderDynamicRouteEnum || (ArcPrerenderDynamicRouteEnum = {}));
export var RouteConfigurationPathKeysEnum;
(function (RouteConfigurationPathKeysEnum) {
    RouteConfigurationPathKeysEnum["Browser"] = "runtime/react-router/browser";
    RouteConfigurationPathKeysEnum["Static"] = "prerender/react-router/static";
})(RouteConfigurationPathKeysEnum || (RouteConfigurationPathKeysEnum = {}));
export const BASE_V1_CSS = [
    "/css/styles.min.css",
    "/css/themes/sb.min.css",
];
export const BASE_V2_CSS = ["/css/v2.min.css"];
export const VOID_V1_THEME_CSS = ["/css/themes/void/void.css"];
